import { TextField } from '@flos/react-ui';
import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { useRecoilState, useRecoilValue } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { type CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { useSaveCoverableInformation } from '../../../../hooks/useSaveCoverableInformation';
import { useState } from 'react';
import { getCoverableIndex } from '../../../../utils/coverablesUtil';
import { track } from '../../../../utils/trackingUtil';
import { useHippoText } from '../../../../hooks/useHippoText';

const DogNameStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const [coverables, setCoverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const getHippoText = useHippoText();

    const { dogs = [] } = coverables;
    const coverableIndex = getCoverableIndex(dogs, currentProduct.fixedId);
    const coverable = dogs[coverableIndex];

    const [dogName, setDogName] = useState<string>(coverable.name ?? '');
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleDogNameBlur = (): void => {
        const updatedCoverables = [...dogs];

        updatedCoverables[coverableIndex] = {
            ...updatedCoverables[coverableIndex],
            name: dogName
        };

        setCoverables((prev) => ({
            ...prev,
            dogs: updatedCoverables
        }));
    };

    const isValid = dogName !== '';

    const onNext = (): void => {
        setIsLoading(true);
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            dog: {
                publicId: coverable.publicId,
                fixedId: coverable.fixedId,
                name: coverable.name
            },
            productToUpdate: currentProduct.flavourName
        };

        void saveCoverableInformation(updatedCoverable).then(() => {
            setIsLoading(false);
            track(`${coverable.flavourName}CoverableInformationNameOfDog`, [{ name: dogName }]);
            goNext();
        });
    };

    return (
        <WizardPagetemplate
            onNext={onNext}
            hidePrevious
            disableNext={!isValid || isLoading}
            isNextLoading={isLoading}
        >
            <CoverableDetailsTemplate
                header={getHippoText('DSS-PET-COVERABLE-INFORMATION-DOG-NAME-QUESTION')}
            >
                <TextField
                    data-testid="dogNameId"
                    label={getHippoText('DSS-PET-COVERABLE-INFORMATION-PET-NAME-INPUT-TOOLTIP')}
                    value={dogName}
                    onChange={(event) => {
                        setDogName(event.target.value);
                    }}
                    onBlur={handleDogNameBlur}
                    minLength={1}
                    required
                    disabled={isLoading}
                />
            </CoverableDetailsTemplate>
        </WizardPagetemplate>
    );
};

export default DogNameStep;
